import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import { NodeSearchPalette } from './NodeSearchPalette';

type EditModeControlsProps = {
  onClearGraph: () => void;
  onResetToLatest: () => void;
  onUndoChanges: () => void;
  filtered: boolean;
};

export const EditModeControls = ({
  onClearGraph,
  onResetToLatest,
  onUndoChanges,
  filtered,
}: EditModeControlsProps): React.ReactElement => {
  return (
    <HStack ml="2" spacing={1}>
      <Menu>
        <MenuButton
          as={Button}
          size="sm"
          variant="ghost"
          fontWeight="normal"
          _hover={{ bg: 'gray.100' }}
        >
          <HStack spacing={1}>
            <Text fontSize="sm">Edit Menu</Text>
            <ChevronDownIcon />
          </HStack>
        </MenuButton>
        <MenuList>
          <MenuItem onClick={onClearGraph}>
            {filtered ? 'Clear Filtered' : 'Clear all'}
          </MenuItem>
          <MenuItem onClick={onUndoChanges}>Undo Changes</MenuItem>
          <MenuItem onClick={onResetToLatest}>
            Reset to Latest Committed Graph
          </MenuItem>
        </MenuList>
      </Menu>
      <Box>
        <NodeSearchPalette />
      </Box>
    </HStack>
  );
};
